import React from 'react';
import About from '../components/About';
import Banner from '../components/Banner';
import Client from '../components/Client';
import Services from '../components/Services';
// import Pricing from '../components/Pricing';
import CTA from '../components/CTA';
import Portfolio from '../components/Portfolio';
import Skills from '../components/Skills';
import Team from '../components/Team';
import FAQ from '../components/FAQ';
import Contact from '../components/Contact';
import WhyUs from '../components/WhyUs';
import Review from '../components/Review';
import Messenger from '../components/common/Messenger';

function Home() {
  return (
    <div>
      <Banner />
      <main id="main">
        <Review />
        {/* <Client /> */}
        <About />
        {/* <WhyUs />
        <Skills /> */}
        <Services />
        <CTA />
        <Portfolio />
        <Team />
        {/* <Pricing /> */}
        <FAQ />
        <Contact />
        <Messenger />
      </main>
    </div>
  );
}

export default Home;
